import request from '../axiosInterceptor'

const api = {
  getNaiConnectConfig() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/config`,
      method: 'get',
    })
  },
  getNaiConnectOverview() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/overview`,
      method: 'get',
    })
  },
  putNaiConnectModule(data: { enabled: boolean }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/config/module`,
      method: 'patch',
      data,
    })
  },
  putNaiConnectIntentDetection(data: { enabled: boolean }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/config/intent-detection`,
      method: 'patch',
      data,
    })
  },
  putNaiConnectPushToNai(data: { enabled: boolean }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/config/push-to-nai`,
      method: 'patch',
      data,
    })
  },
  putNaiConnectApiMode(data: { mode: 'sync' | 'async' }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/config/api-mode`,
      method: 'put',
      data,
    })
  },
  putNaiConnectResponseFields(data: { fields: Record<string, string[]> }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/config/response-fields`,
      method: 'put',
      data,
    })
  },
  putNaiConnectIntentPolicy(data: { intent_value: string[]; risk_category: 'hse' | 'fm'; risk_index_name: string }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/config/intent-policy`,
      method: 'put',
      data,
    })
  },
  postNaiConnectKey(data: { name: string; expiry_at: string }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/keys`,
      method: 'post',
      data,
    })
  },
  postNaiConnectKeyRotate(data?: { expiry_at: string }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/keys/rotate`,
      method: 'post',
      data,
    })
  },
  postNaiConnectKeyRevoke() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/keys/revoke`,
      method: 'post',
    })
  },
  postNaiConnectDocumentationDownloaded() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/documentation/downloaded`,
      method: 'post',
    })
  },
  getNaiConnectAuditLog({ page = 1, pageSize = 20 }: { page?: number; pageSize?: number } = {}) {
    const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) })
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/audit-log?${params.toString()}`,
      method: 'get',
    })
  },
  getNaiConnectRequestLog({ page = 1, pageSize = 20 }: { page?: number; pageSize?: number } = {}) {
    const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) })
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/request-log?${params.toString()}`,
      method: 'get',
    })
  },
  getNaiConnectProjects() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/projects`,
      method: 'get',
    })
  },
  getNaiConnectProjectUsers(projectDetailsId: number) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/projects/${projectDetailsId}/users`,
      method: 'get',
    })
  },
  patchNaiConnectProjectToggle(projectDetailsId: number, data: { enabled: boolean; reporter_user_id?: string }) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/admin/projects/${projectDetailsId}/toggle`,
      method: 'patch',
      data,
    })
  },
}

export default api
